export default {
    ELEGIVEL_AD1: 1,
    ELEGIVEL_AD2: 2,
    ELEGIVEL_AD3: 3,
    INELEGIVEL: 4,
}